import axiosInstance from "./axios";

// Event occurrence social endpoints (backend: blorp/views/event_engagement.py).
// Comments go through CommentAPI with an occurrence target. Errors are
// rethrown as-is: 404 outside the occurrence's audience, 409 { code } when
// engagement isn't open (occurrence_canceled / occurrence_not_started /
// occurrence_private).

// GET /event-occurrences/<id>/preview/ — the lightweight view every Home
// event-start card opens:
//   { id, title, creator, starts_at, timezone, is_all_day, status,
//     engagement, can_view_full_detail }
// title and is_all_day are already this occurrence's effective values; there
// is no ends_at. engagement is null while the occurrence is private or hasn't
// started, else { can_engage, like_count, is_liked, reaction_counts,
// my_reaction, comment_count }.
export async function fetchOccurrencePreview(occurrenceId) {
  const { data } = await axiosInstance.get(`/event-occurrences/${occurrenceId}/preview/`);
  return data;
}

// Explicit like / unlike (never a toggle, so an unlike after cancellation
// can't become a like). → { is_liked, likes_count }
export async function setOccurrenceLike(occurrenceId, liked) {
  const url = `/event-occurrences/${occurrenceId}/like/`;
  const { data } = liked ? await axiosInstance.post(url, {}) : await axiosInstance.delete(url);
  return data;
}

// POST adds or switches the viewer's reaction (the same type again removes
// it); DELETE removes it, which a canceled occurrence still accepts.
// → { my_reaction, reaction_counts }
export async function reactToOccurrence(occurrenceId, reactionType) {
  const { data } = await axiosInstance.post(`/event-occurrences/${occurrenceId}/reaction/`, {
    reaction_type: reactionType,
  });
  return data;
}

export async function removeOccurrenceReaction(occurrenceId) {
  const { data } = await axiosInstance.delete(`/event-occurrences/${occurrenceId}/reaction/`);
  return data;
}
